import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";
import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons";
import { useInputDialog } from "src/components/common/dialogs/input/useInputDialog.tsx";
import i18n from "i18next";
import { uploadFile } from "src/utils/fileUploading.ts";
import { CustomerOrderLineTabularImportApi } from "src/api/generated/erp/sales/customerOrder/api/customerOrderLineTabularImportApi.ts";

export interface ImportCustomerOrderLinesFromTabularDataButtonProps {
	customerOrderId: number;
	afterImport?: () => Promise<unknown>;
}

export const ImportCustomerOrderLinesFromTabularDataButton = ({
	customerOrderId,
	afterImport,
}: ImportCustomerOrderLinesFromTabularDataButtonProps) => {
	const { tenantConfig } = useTenantCustomizations();
	const showInputDialog = useInputDialog();
	if (!tenantConfig.erp.customerOrderLineImportMethods.includes("STANDARD_TABULAR")) return null;

	return (
		<AsyncMenuButton
			label={i18n.t("import_customer_order_lines")}
			icon={faFileImport}
			onClick={async () => {
				const file = await showInputDialog({
					type: "singleFile",
					title: i18n.t("select_a_file"),
					defaultValue: null,
					required: true,
				});
				if (file === undefined) return;

				const fileHandle = await uploadFile(file);

				await CustomerOrderLineTabularImportApi.importLines({
					customerOrderId: customerOrderId,
					fileHandle: fileHandle,
				});
				await afterImport?.();
			}}
		/>
	);
};
